import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faChevronDown, faEnvelopeOpenText, faQuestion, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { select } from '@ngxs/store';
import { AppUrls } from '../../../../../../common/dto/app-urls';
import { Environment } from '../../../../environments/environment.interface';
import { AppState } from '../../../app.state';
import { AuthenticationService } from '../../../common/services/authentications.service';
import { ENVIRONMENT } from '../../../common/services/injection-tokens';

@Component({
  selector: 'app-user-menu',
  imports: [MatButtonModule, FaIconComponent, MatMenuModule, RouterLink],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent {
  constructor(
    private _authenticationService: AuthenticationService,
    @Inject(ENVIRONMENT) protected environment: Environment,
  ) {
  }

  protected appState = select(AppState.get);

  protected async logoutAsync() {
    await this._authenticationService.logoutAsync();
  }

  protected readonly faChevronDown = faChevronDown;
  protected readonly faRightFromBracket = faRightFromBracket;
  protected readonly RouteLocations = AppUrls;
  protected readonly faEnvelopeOpenText = faEnvelopeOpenText;
  protected readonly AppUrls = AppUrls;
  protected readonly faQuestion = faQuestion;
}
